<div
    class="container-item"
    [class.disabled]="disabled()"
    [testId]="id()">

    <!-- Ícone com fundo na cor do tipo -->
    <div
        class="container-icon"
        [class.green]="color() === 'green'"
        [class.orange]="color() === 'orange'"
        [class.neutral]="color() === 'neutral'">
        <ra-icon [icon]="icon()" [varColor]="iconColor()" [size]="24" />
    </div>

    <!-- Título + descrição -->
    <div class="container-texts">
        <p class="title">{{ title() }}</p>
        <p class="description">{{ description() }}</p>
    </div>

    <!-- Selo "Em breve" ou seta -->
    @if (badge()) {
        <span class="badge">{{ badge() }}</span>
    } @else {
        <ra-icon class="arrow" icon="arrow-right" varColor="contentSecondary" [size]="20" />
    }
</div>
